import './MyLeafBox.scss';

const MyLeafBox = (props) =>
{
  const size = props.size || 4;
  const hasNumber = typeof props.number != "undefined" ? true : false;
  const ornament = typeof props.ornament != "undefined" && props.ornament === false ? 'no-ornament' : '';

  return (
    <div className={`pb-4 col-md-${size} col-lg-${size}`}>
      <div className={`leaf-2 ${(typeof props.thin != "undefined" ? 'thin' : '')} ${hasNumber ? '' : 'no-number'} p-3 ${ornament}`}>
        <div className="ornament-right">
          <svg width="111" height="75" viewBox="0 0 111 75" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4266_6380)">
              <rect width="101.167" height="101.167" rx="12" transform="matrix(0.692765 -0.721163 0.692765 0.721163 56.0842 21.9816)" fill="#F2A900" fillOpacity="0.05"></rect>
              <rect width="101.167" height="101.167" rx="12" transform="matrix(0.692765 -0.721163 0.692765 0.721163 0 2.05969)" fill="#F2A900" fillOpacity="0.05"></rect>
            </g>
            <defs>
              <clipPath id="clip0_4266_6380">
                <path d="M0 0H87C100.255 0 111 10.7452 111 24V75H0V0Z" fill="white"></path>
              </clipPath>
            </defs>
          </svg>
        </div>
        {hasNumber && (
        <div className="advantage-number rounded-circle d-flex align-items-center justify-content-center mb-3">{props.number}</div>
        )}
        <p className="advantage-title mb-2"  dangerouslySetInnerHTML={{ __html: props.title }}></p>

        {typeof props.description != "undefined" && props.description.length > 0 && (
        <p className="advantage-desc" dangerouslySetInnerHTML={{ __html: props.description }}></p>
        )}
      </div>
    </div>
  );
}

export default MyLeafBox;
